import { ModalController } from "./modal/controller.js";

export class Slider {
  constructor(_idElem, _images, _canOpen, _runOnInit, _title, _isBanner) {
    this.idElem = _idElem;
    this.images = _images;
    this.canOpen = _canOpen || false;
    this.runOnInit = _runOnInit || false;
    this.title = _title || false;
    this.isBanner = _isBanner || false;

    this.container = document.createElement('div');
    this.container.classList.add('slider');
    this.visor = document.createElement('div');
    this.visor.onclick = this.open.bind(this);
    this.visor.classList.add('image');
    this.visorPrev = document.createElement('div');
    this.controls = document.createElement('div');
    this.controls.onclick = this.open.bind(this);
    this.controls.classList.add('controls');
    this.position = -1;
    this.timer = null;
    this.buttons = [];
    // if (Array.isArray(_images) && _images.length > 0) {
    this.init();
    // } else {
    // this.visor.setAttribute('style', `background-image: url(/assets/img/service.webp)`);
    // }
  }

  init() {

    // Generate Buttons
    if (this.images.length > 1) {
      for (let i = 0; i < this.images.length; i++) {
        let button = document.createElement('div');
        button.classList.add('dot');
        button.onclick = this.show.bind(this);
        button.setAttribute('pos', i);
        this.buttons.push(button);
        this.controls.appendChild(button);
      }
    }

    this.container.appendChild(this.visor);
    this.container.appendChild(this.controls);
    if (document.getElementById(this.idElem)) {
      document.getElementById(this.idElem).innerHTML = '';
      document.getElementById(this.idElem).appendChild(this.container);
    }

    // Load First photo
    if (Array.isArray(this.images) && this.images.length > 0) {
      let image = this.getImage(0);
      this.visor.setAttribute('style', `background-image: url(${resolvePath(image.path, false)})`);
    } else {
      // this.visor.setAttribute('style', `background-image: url(/assets/img/service.webp)`);
      return;
    }
    this.load();
    if (this.runOnInit) {
      this.play();
    }
  }

  getImage(_position) {
    let path = '';
    let link = '';
    if (this.images[_position]) {
      let image = this.images[_position];
      if (Array.isArray(image)) {
        path = image[0];
        link = image[1];
      } else {
        path = image;
      }
    }
    return { path, link };
  }

  load() {
    if ((this.position + 1) < this.images.length) {
      this.position++;
    } else {
      this.position = 0;
    }

    let image = this.getImage(this.position);
    let imagePrev = this.getImage(this.position + 1);

    this.visor.setAttribute('style', `background-image: url(${resolvePath(image.link, false)})`);
    this.visorPrev.setAttribute('style', `background-image: url(${resolvePath(imagePrev.link, false)})`);

    if (image.link != '' && this.isBanner === true) {
      this.visor.setAttribute('onclick', `window.open('${image.link}', '_blank')`);
    }

    if (this.images.length > 1) {
      for (let i = 0; i < this.buttons.length; i++) {
        this.buttons[i].classList.remove('active');
      }
      this.buttons[this.position].classList.add('active');
    }
  }

  show(event) {
    event.stopPropagation();
    event.preventDefault();
    if (event.target.getAttribute('pos')) {
      this.position = parseInt(event.target.getAttribute('pos')) - 1;
      this.load();
      this.pause();
      this.play();
    }
  }

  pause() {
    clearInterval(this.timer);
  }

  play() {
    this.timer = setInterval(this.load.bind(this), 7000);
  }

  open(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.canOpen) {
      new ModalController(this.title || '', `
      <img class="image-autowidth" src="${resolvePath(this.images[this.position], false)}">
      `, 'full');
    }
  }
}

export function resolvePath(_image, _thumb) {
  if (_image.indexOf('/') > -1) {
    return _image;
  } else {
    return APICRUD.Image.GetUrl(_image, _thumb);
  }

}

export function sliderInModal(_images, _position) {
  new ModalController(this.title || '', `
      <img class="image-autowidth" src="${resolvePath(this.images[this.position], false)}">
      `, 'full');
}
